const getNestedData = ({ object, path }) => {
	path = path.replace(/\[(\w+)\]/g, ".$1")
	path = path.replace(/^\./, "")
	const keys = path.split(".")

	for (const key of keys) {
		if (Boolean(object) && key in object) object = object[key]
		else return
	}

	return object
}

export default getNestedData
